// Shared Fountain screenplay parsing constants and helpers.
// Used by both SimpleScreenplayViewer.js (interactive editor) and
// SidesPrinter.js (print-only sides generation) so the two stay in sync.

// Canonical list of scene heading prefixes — used by both the parser and the
// autocomplete dropdown in the editor.
export const SCENE_PREFIXES = [
  'INT.', 'EXT.', 'INT/EXT.', 'INT./EXT.', 'I/E.', 'EST.',
  'ESTABLISHING', 'INTERCUT', 'FLASHBACK',
  'MONTAGE', 'SERIES OF SHOTS', 'BEGIN MONTAGE', 'END MONTAGE',
  'POV', 'INSERT'
];

// Common screenplay transitions (Fountain spec + industry conventions).
export const TRANSITIONS = [
  'FADE IN:',
  'FADE OUT',
  'FADE OUT:',
  'FADE TO BLACK',
  'FADE UP',
  'DISSOLVE TO:',
  'SMASH CUT TO:',
  'QUICK CUT TO:',
  'MATCH CUT TO:',
  'JUMP CUT TO:',
  'MATCH DISSOLVE TO:',
  'CUT TO BLACK',
  'FLASH CUT TO:',
  'TIME CUT:',
  'BACK TO:',
  'CROSSFADE TO:',
  'SLOW FADE TO:',
  'SLOW DISSOLVE TO:',
  'RIPPLE DISSOLVE TO:',
  'WIPE TO:',
  'IRIS WIPE TO:',
  'TRANSITION TO:',
  'CUT TO:'
];

// Standard character extensions (parentheticals after character cues).
export const CHARACTER_EXTENSIONS = [
  'O.S.',
  'V.O.',
  "CONT'D",
  'OFF',
  'OS',
  'VO',
  'FILTER',
  'THROUGH DEVICE',
  'ON PHONE',
  'ON RADIO',
  'OVER RADIO',
  'ON SPEAKER',
  'ON MEGAPHONE',
  'PRE-LAP',
  'OFF SCREEN'
];

// Normalize \r\n and \r to \n so the rest of the parser only deals with \n.
export const normalizeNewlines = (str = '') =>
  str.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

// True if a trimmed line is a known transition or matches the `... TO:` pattern.
export const isTransitionLine = (line = '') => {
  const upper = line.trim().toUpperCase();
  if (!upper) return false;
  return TRANSITIONS.includes(upper) ||
    (upper.endsWith('TO:') && upper === upper.toUpperCase());
};

// Standardize a character extension parenthetical against the known list.
// Returns the standardized `(EXT)` form, or the raw extension if unrecognized.
export const standardizeExtension = (rawExtension = '') => {
  const upperExt = rawExtension.toUpperCase().replace(/[()]/g, '').trim();
  const standardExt = CHARACTER_EXTENSIONS.find(ext =>
    upperExt === ext ||
    upperExt === ext.replace(/\./g, '') ||
    ext.includes(upperExt)
  );
  return standardExt ? `(${standardExt})` : rawExtension.trim();
};
